import clsx from "clsx";

import { ArcadeTimer } from "../../../shared/components/arcade-timer.component";
import { WORD_SEARCH_POINT_PER_WORD, WORD_SEARCH_ROUND_LIMIT_SECONDS } from "../../word-search.constants";
import { Word, WordSearchGameStatus, WordSearchRound } from "../../word-search.types";

interface Props {
  readonly round: WordSearchRound | null;
  readonly words: Word[];
  readonly wordsFound: number;
  readonly status: WordSearchGameStatus;
  readonly onTimeout: () => void;
}

export function WordSearchBanner({ round, words, wordsFound, status, onTimeout }: Props) {
  if (!round) {
    return null;
  }

  return (
    <div
      className={clsx(
        "word-search__banner",
        status === WordSearchGameStatus.WON && "round--completed"
      )}
    >
      <div className="word-search-black-banner--left">
        <div className="word-search-black-banner--entries-container">
          <div className="word-search-black-banner--left-entries">
            <span>+{words.length * WORD_SEARCH_POINT_PER_WORD}</span> points
          </div>
        </div>
        <div className="word-search-black-banner--left-tiles">
          <div className="word-search-black-banner--left-correct-tiles">
            words found: {wordsFound}/{words.length}
          </div>
          <span className="word-search-black-banner--left-sponsored">This round sponsored by {round.brandName}</span>
          <div className="word-search-black-banner--left-logo">
            <img src={round.media.logoUrl} alt="Brand logo" />
          </div>
        </div>
      </div>
      <div className="word-search__banner__center">
        <ArcadeTimer
          isRunning={status === WordSearchGameStatus.STARTED}
          time={WORD_SEARCH_ROUND_LIMIT_SECONDS}
          onTimeout={onTimeout}
          gameStatus={status}
        />
      </div>
      <div className="word-search__banner__right">
        <img
          className="word-search__banner__right--brand-logo"
          src={round.media.logoUrl}
          alt="Brand logo"
        />
        <div className="word-search__banner__right--short-description">
          {round.brandDescription}
        </div>
      </div>
    </div>
  );
}
